import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';

var FORGEROCK_ACCOUNT_TYPES = {
  SSLA_OTT: 'SSLA-OTT',
  BR_OTT: 'BR-OTT',
  LATAM_OTT: 'LATAM-OTT',
  LATAM_DTH: 'LATAM-DTH',
  SSLA_DTH: 'SSLA-DTH',
  SKY_DTH: 'SKY-DTH',
  MSO_DTH: 'MSO-DTH'
};
var USER_TYPES = {
  OTT_D2C: 'OTT-D2C',
  TVE: 'TVE',
  OTT_B2B2C: 'OTT-B2B2C'
};
var MSO_PROVIDERS_TYPES = {
  GRAN_HERMANO: 'gran hermano'
};
var getUserTypeByBusinessUnit = function getUserTypeByBusinessUnit(businessUnit) {
  var _userTypesByBusinessU;
  var userTypesByBusinessUnit = (_userTypesByBusinessU = {}, _defineProperty(_userTypesByBusinessU, FORGEROCK_ACCOUNT_TYPES.SSLA_OTT, USER_TYPES.OTT_D2C), _defineProperty(_userTypesByBusinessU, FORGEROCK_ACCOUNT_TYPES.BR_OTT, USER_TYPES.OTT_D2C), _defineProperty(_userTypesByBusinessU, FORGEROCK_ACCOUNT_TYPES.LATAM_OTT, USER_TYPES.OTT_D2C), _defineProperty(_userTypesByBusinessU, FORGEROCK_ACCOUNT_TYPES.LATAM_DTH, USER_TYPES.OTT_D2C), _defineProperty(_userTypesByBusinessU, FORGEROCK_ACCOUNT_TYPES.SSLA_DTH, USER_TYPES.TVE), _defineProperty(_userTypesByBusinessU, FORGEROCK_ACCOUNT_TYPES.SKY_DTH, USER_TYPES.TVE), _defineProperty(_userTypesByBusinessU, FORGEROCK_ACCOUNT_TYPES.MSO_DTH, USER_TYPES.OTT_B2B2C), _userTypesByBusinessU);
  return userTypesByBusinessUnit[businessUnit] || businessUnit;
};

/**
 * @description Returns the mso provider formatted
 * @param {string} msoProvider
 * @param {string} businessUnit
 * @return {string}
 */
function getMSOProviderFormatted(_ref) {
  var msoProvider = _ref.msoProvider,
    businessUnit = _ref.businessUnit;
  if (businessUnit === FORGEROCK_ACCOUNT_TYPES.MSO_DTH) {
    return msoProvider ? "".concat(msoProvider, "-OTT").toUpperCase() : 'MISSING-OTT';
  }
  if ((msoProvider === null || msoProvider === void 0 ? void 0 : msoProvider.toLowerCase()) === MSO_PROVIDERS_TYPES.GRAN_HERMANO) {
    return msoProvider;
  }
  return businessUnit;
}

export { FORGEROCK_ACCOUNT_TYPES, MSO_PROVIDERS_TYPES, USER_TYPES, getMSOProviderFormatted, getUserTypeByBusinessUnit };
//# sourceMappingURL=user.js.map
